<form (ngSubmit)="onSubmit()" [formGroup]="form" class="form">
  <form-wrapper>
    <ng-container formArrayName="products">
      @for (product of products.controls; track product; let index = $index) {
        @if (index == 0) {
          <ng-container [formGroup]="product">
            <ng-container formGroupName="parameters">
              <div class="row">
                <div class="col col-md-12">
                  <pr-input-column
                    label="{{
                      operation === 'TRANSFER'
                        ? 'Numéro de l\'ancien contrat'
                        : 'Numéro de contrat'
                    }}"
                    [derrors]="derrors"
                    [isDefault]="false"
                  >
                    <input formControlName="contractNumber" type="text" />
                  </pr-input-column>
                </div>
              </div>
              @if (['TRANSFER'].includes(operation)) {
                <div class="row mt-1">
                  <div class="col col-md-12">
                    <pr-input-column
                      label="Numéro du nouveau contrat"
                      [derrors]="derrors"
                      [isDefault]="false"
                    >
                      <input formControlName="newContractNumber" type="text" />
                    </pr-input-column>
                  </div>
                </div>
              }
              @if (['SUSPENSION_INDEXATION', 'TRANSFER'].includes(operation)) {
                <div class="row mt-1">
                  <div class="col col-md-12">
                    <div style="width: calc(100% - 27px)">
                      <pr-input-date
                        formControlName="contractStartDate"
                        label="Date de début du contrat"
                        label="{{
                          operation === 'TRANSFER'
                            ? 'Date de début du contrat d\'origine'
                            : 'Date de début du contrat'
                        }}"
                        [derrors]="derrors"
                        [isDefault]="false"
                      ></pr-input-date>
                    </div>
                  </div>
                </div>
              }
              @if (!['TRANSFER', 'ORDRE_DE_REMPLACEMENT'].includes(operation)) {
                <div class="row mt-1">
                  <div class="col col-md-12">
                    <pr-input-radio
                      formControlName="hasSituationChange"
                      columns="3"
                      [toggle]="true"
                      [isDefault]="false"
                      label="Est-ce que vous avez eu un changement de situation ?"
                    >
                    </pr-input-radio>
                  </div>
                </div>
              }
            </ng-container>
          </ng-container>
        }
      }
    </ng-container>
  </form-wrapper>
  <form-footer (prev)="prev()" (next)="onSubmit()"></form-footer>
</form>
